import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  appPageTable: {
    width: "100%",
    minWidth: "100%",
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column"
  }
}));
